//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FamilyMembers from "./components/FamilyMembers";
import FamilyLand from "./components/FamilyLand";
export default {
  name: "ResourceHumanDetail",
  components: {
    FamilyMembers,
    FamilyLand,
  },
  data() {
    return {
      id: "",
      detail: {},
      isRequest: false,
      activeName: "first",
    };
  },
  filters: {
    formatSex(value) {
      let result = "";
      switch (value) {
        case 1:
          result = "男";
          break;
        case 0:
          result = "女";
          break;
      }
      return result;
    },
    formatIsHolder(value) {
      let result = "";
      switch (value) {
        case 1:
          result = "是";
          break;
        case 0:
          result = "否";
          break;
      }
      return result;
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getVillPersonDetail();
  },
  methods: {
    /**
     * @descripttion: 获取村民详情
     * @Author: juanjuanhui
     * @Date: 2021-11-25 10:45:30
     * @param {*}
     */
    getVillPersonDetail() {
      this.$http.village.getVillPersonDetail({ id: this.id }).then((res) => {
        this.detail = res.data;
        this.isRequest = true;
      });
    },
  },
};
